/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import PropTypes from 'prop-types';

import Input from 'relements/build/esm/input/text';
import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';

import Bulb from './assets/bulb.svg';
import Tick from './assets/tick.svg';

import InviteNotification from '../InviteNotification';

import {
  Container,
  IconBox,
  SvgIcon,
  Title,
  Description,
  Message,
  MessageBox,
  MessageIconBox,
  InputStyle,
  InputBox,
  InviteButton,
} from './styledComponents';

function InviteYourFriend({
  isExpanded,
  setIsExpanded,
  description,
  disabled,
  value,
  onChange,
  messageType,
  message,
  sendInvite,
}) {
  const isSuccess = messageType === 'success';
  const Icon = isSuccess ? (
    <SvgIcon src={Tick} height="8px" width="8px" />
  ) : (
    <Text color="background" variant="h4.semi-bold">
      !
    </Text>
  );

  return (
    <Container isExpanded={isExpanded}>
      <Box padding="zero" alignItems="center">
        <IconBox>
          <SvgIcon src={Bulb} height="21px" width="22px" />
        </IconBox>
        <Title variant="h1.semi-bold" color="black.haptik">
          Invite your friend
        </Title>
        <SvgIcon
          src={isExpanded ? 'caretUp' : 'caretDown'}
          height="7px"
          width="14px"
          onClick={setIsExpanded}
        />
      </Box>
      {isExpanded && (
        <Box padding="zero" flexDirection="column">
          {description && (
            <Description variant="body.lg">{description}</Description>
          )}
          <InputBox>
            <Input
              themed
              placeholder="Enter your colleague’s email address"
              style={InputStyle}
              value={value}
              onChange={onChange}
            />
            <InviteButton
              themed
              disabled={disabled}
              variant={disabled ? 'disabled' : 'primary'}
              onClick={sendInvite}
            >
              Send Invite
            </InviteButton>
          </InputBox>
          {message && (
            <MessageBox>
              <MessageIconBox isSuccess={isSuccess}>{Icon}</MessageIconBox>
              <Message variant="body.md" isSuccess={isSuccess}>
                <InviteNotification message={message} />
              </Message>
            </MessageBox>
          )}
        </Box>
      )}
    </Container>
  );
}

InviteYourFriend.propTypes = {
  isExpanded: PropTypes.bool,
  setIsExpanded: PropTypes.func,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  messageType: PropTypes.string,
  message: PropTypes.string,
  sendInvite: PropTypes.func,
};

InviteYourFriend.defaultProps = {
  isExpanded: true,
  setIsExpanded: () => {},
  description: '',
  disabled: false,
  value: '',
  onChange: () => {},
  messageType: '',
  message: '',
  sendInvite: () => {},
};

export default React.memo(InviteYourFriend);
